<template>
  <div :class="{ 'pointer-events-none': !clickable }" class="w-full overflow-hidden event-wrapper relative">
    <div v-if="type === 'news'" ref="slider" class="h-9 flex">
      <div v-for="item in news" :key="item.slug" class="py-1 px-4 inline-block whitespace-no-wrap event-li">
        <span class="text-orange-brand mx-3">{{ item.date }}</span>{{ item.title }}
      </div>
    </div>
    <div v-else ref="slider" class="h-9 flex">
      <div v-for="(word, count) in words" :key="count" class="py-1 inline-block whitespace-no-wrap event-li">
        <span class="stroke" v-if="count % 2 === 1" v-text="word" />
        <span v-else v-text="word" />
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from 'flickity'
export default {

  name: 'BaseSlider',

  props: ['type', 'string', 'separator'],

  data () {
    return {
      isDragging: false,
      flkty: null,
      tickerSpeed: 1,
      isPaused: false,
      maxSize: null,
      loaded: false,
      clickable: false
    }
  },
  computed: {
    currentEvents () {
      return this.$store.getters.tickerEvents
    },
    cellHeight () {
      if (!this.maxSize) return
      return `${this.maxSize}px`
    },
    wrapperHeight () {
      return `${this.loaded ? this.maxSize : 0}px`
    },
    news () {
      return this.localeList(this.$store.state.news).slice(0, 5)
    },
    words () {
      if (this.string) {
        var words = this.string.split(' ')
        for (var i = 0; i < 20; i++) {
          words = words.concat(this.string.split(' '))
        }
        return words
      } else {
        return ''
      }
      // return Array.apply(null, Array(20)).map(_ => this.$props.string)
      // return new Array(15).fill(this.$props.text)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.start()
      setTimeout(() => {
        this.loaded = true
      }, 10)
      setTimeout(() => {
        this.clickable = true
      }, 1050)
    })
  },
  methods: {
    start () {
      const el = this.$refs.slider

      this.flkty = new Flickity(el, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25,
        percentPosition: false,
        setGallerySize: true,
        freeScroll: true,
        pauseAutoPlayOnHover: false,
        cellAlign: 'left'
      })

      this.flkty.on('dragStart', () => {
        this.isDragging = true
        this.isPaused = true
      })
      this.flkty.on('dragEnd', () => {
        setTimeout(() => {
          this.isDragging = false
        }, 10)
      })
      this.flkty.x = 0

      // el.addEventListener('mouseenter', this.pause, false)
      // el.addEventListener('focusin', this.pause, false)
      el.addEventListener('mouseleave', this.play, false)
      el.addEventListener('focusout', this.play, false)

      this.update()
    },
    update () {
      if (this.isPaused) return
      if (this.flkty.slides) {
        this.flkty.x = (this.flkty.x - this.tickerSpeed) % this.flkty.slideableWidth
        this.flkty.selectedIndex = this.flkty.dragEndRestingSelect()
        this.flkty.updateSelectedSlide()
        this.flkty.settle(this.flkty.x)

        this.maxSize = this.flkty.maxCellHeight
      }
      window.requestAnimationFrame(this.update)
    },
    pause () {
      this.isPaused = true
    },
    play () {
      if (this.isPaused) {
        this.isPaused = false
        window.requestAnimationFrame(this.update)
      }
    },
    link (event) {
      if (this.isDragging) return ''
      return this.getPathFromUrl(event.link)
    },
    locale () {
      return this.$store.state.locale
    }
  },
  watch: {
    news () {
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.flkty.resize()
        }, 600)
      })
    },
    words () {
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.flkty.resize()
        }, 600)
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .stroke {
    -webkit-text-fill-color: white; /* Will override color (regardless of order) */
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
  }
</style>
